import { environment } from "environments/environment.staging";

export class Utils {
  tagsColorsMap: { [key: number]: string } = {};
  badgeColors = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "dark",
  ];

  getAuthorImage(postItem): string {
    return postItem?.author?.media?.url
      ? environment.mediaUrl + "/" + postItem.author.media.url
      : "assets/images/logo/logo.svg";
  }

  getAuthorImageByMedia(author): string {
    return author?.media?.url
      ? environment.mediaUrl + "/" + author.media.url
      : "assets/images/logo/logo.svg";
  }

  getFirstMedia(postItem: any): any {
    if (!postItem?.media || postItem.media.length === 0) return null;
    return postItem.media[0];
  }

  isImage(media: any): boolean {
    return media?.type === "IMAGE";
  }

  isVideo(media: any): boolean {
    return media?.type === "VIDEO";
  }

  getPostImages(postItem): string[] {
    if (postItem?.media?.length > 0) {
      return postItem.media.map(
        (item) => environment.mediaUrl + "/" + item.url
      );
    }
    return ["assets/images/default-placeholder.png"]; // صورة افتراضية إذا لم تكن هناك صور
  }

  getTagColor(tagId: number): string {
    if (this.tagsColorsMap[tagId]) {
      return this.tagsColorsMap[tagId];
    }

    const randomColor =
      this.badgeColors[Math.floor(Math.random() * this.badgeColors.length)];
    this.tagsColorsMap[tagId] = randomColor;
    return randomColor;
  }

  getFirstImage(postItem): string {
    return postItem?.media?.length
      ? environment.mediaUrl + "/" + postItem.media[0].url
      : "assets/images/default-placeholder.png";
  }

  getFormattedDescription(description: string, mentionedUsers: any[]): string {
    if (!description || !mentionedUsers) return description;

    // Replace each {{User:ID}} with the corresponding user's name
    return description.replace(/\{\{User:(\d+)\}\}/g, (match, userId) => {
      const user = mentionedUsers.find((u) => u.id == userId);
      return user ? `${user.firstName} ${user.lastName}` : match; // Fallback to original text if user not found
    });
  }
}
